/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
/**
 * SVG icon component.
 */
export function FreezeHeader({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}><g fill="currentColor"><path d="M12.5.9a2.6 2.6 0 0 1 2.6 2.6v3.165c0 .454-.652.687-1.008.406a.49.49 0 0 1-.192-.383V3.5a1.4 1.4 0 0 0-1.4-1.4h-9a1.4 1.4 0 0 0-1.4 1.4v9a1.4 1.4 0 0 0 1.4 1.4h3.4a.6.6 0 1 1 0 1.2H3.5a2.6 2.6 0 0 1-2.6-2.6v-9A2.6 2.6 0 0 1 3.5.9zM12 3.4a.6.6 0 1 1 0 1.2H4a.6.6 0 1 1 0-1.2z" /><path d="M11.799 7c.266 0 .482.215.482.482v.896l.475-.444a.482.482 0 1 1 .659.703L12.281 9.7v.917h1.011l.955-1.118a.482.482 0 0 1 .732.627l-.418.49h.856a.483.483 0 0 1 0 .966h-.942l.473.457a.483.483 0 0 1-.67.694l-1.195-1.152h-.802v.817l1.14 1.108a.482.482 0 1 1-.672.692l-.468-.455v.974a.483.483 0 0 1-.965 0v-.901l-.498.409a.483.483 0 0 1-.611-.746l1.11-.912v-.985H10.5l-1.107 1.14a.482.482 0 1 1-.692-.673l.454-.467h-.973a.483.483 0 0 1 0-.965h.901l-.41-.498a.483.483 0 0 1 .747-.612l.911 1.11h.985V9.7l-1.133-1.063a.483.483 0 0 1 .66-.703l.473.443v-.895c0-.266.217-.482.483-.483" /></g></svg>;
}
;